var map = {
	"./donation.jpg": "43+T",
	"./fee.jpg": "/P9V",
	"./merchandise.jpg": "KHot"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "38gy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping ^\.\/.*$
// module id = 38gy
// module chunks = 0